import React, { MouseEvent, StatelessComponent } from 'react';
import cls from '../utils/classnames';
import { FOCUSABLE, FOCUSABLE_ROUNDED } from '../utils/classes';
import Utils from '../../../../utils/Utils';
import './_styles.scss';

export interface IFocusableProps {
    /**
     * id to add to element
     */
    id?: string;
    /**
     * class name to add to element
     * */
    className?: string;
    /**
     * handle on click of element
     */
    onClick?: (event: MouseEvent<{}>) => unknown;
    /**
     * flag to add a rounded border to focus
     */
    rounded?: boolean;

    blockedRight?: object;

    onMouseEnter?: (event: MouseEvent<HTMLElement>) => void;
}

/**
 * This component is to emulate a focusable area in order to Spatial Navigation recognize as a focusable element
 */
export const Focusable: StatelessComponent<IFocusableProps> = props => {
    let { id, className, onClick, rounded = false, children, blockedRight, onMouseEnter } = props;
    const classNames = cls(FOCUSABLE, className, {
        [FOCUSABLE_ROUNDED]: rounded
    });
    id = id ? id : String(`keyP-${Math.floor(10000 + Math.random() * 90000)}`)

    const handleMouseEnter = (e: any) => {
        Utils.handleMouseEnter(e)
    }

    return (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid, no-script-url
        <a id={id} className={classNames} onClick={onClick} onMouseEnter={() => handleMouseEnter(id)}  href="javascript:void(0)"  {...blockedRight}>
            {children}
        </a>
    );
};



// WEBPACK FOOTER //
// ./src/packages/components/lib/Focusable/index.tsx